import styled from 'styled-components/macro';
import {useState} from "react";
import {
    Button,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalFooter,
    ModalHeader,
    ModalOverlay,
    Radio,
    RadioGroup,
    Stack
} from "@chakra-ui/react";
import {useFeedback} from "../store/feedback";
import {useReport} from "../api/report";
import {useCommunityReportReasons} from "../api/report_reasons";

const ReportItem = styled(({className, post, comment, onClose}) => {
    const community = post ? post.community : comment.community;
    const {error, feedbackCh} = useFeedback();
    const report = useReport(feedbackCh);
    const customReasons = useCommunityReportReasons(feedbackCh, community)?.rules;
    const [reportReason, setReportReason] = useState();
    const [communityRule, setCommunityRule] = useState();
    const showCustomReasons = reportReason === 'communityRules' && customReasons?.length > 0;
    const handleReport = async () => {
        try {
            await report(
                post ? post.id : comment.id,
                Boolean(post),
                reportReason,
                reportReason === 'communityRules' ? communityRule : ''
            );
            onClose();
        } catch {
            // error is displayed
        }
    };
    return (
        <Modal
            isOpen
            onClose={onClose}
        >
            <ModalOverlay />
            <ModalContent>
                <ModalHeader>Report this {post ? 'post' : 'comment'}</ModalHeader>
                <ModalCloseButton />
                <ModalBody pb={6}>
                        {!showCustomReasons && (
                            <RadioGroup name='reportReason' onChange={setReportReason} value={reportReason}>
                            <Stack>
                                <Radio value="communityRules">
                                    Breaks c/{community}'s rules
                                </Radio>
                                <Radio value="spam">Spam or Self Promotion</Radio>
                                <Radio value="platformMisuse">Platform Misuse</Radio>
                                <Radio value="csam">Sexualization of Minors</Radio>
                                <Radio value="illegalContent">Other Illegal Content</Radio>
                            </Stack>
                            </RadioGroup>
                        )}
                        {showCustomReasons && (
                            <RadioGroup name='customReason' onChange={setCommunityRule} value={communityRule}>
                                <Stack>
                                    {customReasons?.map((reason, i) =>
                                        // eslint-disable-next-line react/no-array-index-key
                                        <Radio key={i} value={reason}>{reason}</Radio>
                                    )}
                                </Stack>
                            </RadioGroup>
                        )}
                </ModalBody>

                <ModalFooter>
                    <Button variant="cancel" mr={3} onClick={onClose}>Cancel</Button>
                    <Button variant="blue" onClick={handleReport}>
                        Send
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
})`
`;

export default ReportItem;
